import React, { useEffect, useState } from 'react'
import { IDriverManifestsDriver, IDriverManifestsTrip } from 'src/types/driver-manifests'
import UpdatedTooltip from '../ui/UpdatedTooltip'

interface IDriverManifestsDriverItemProps {
  drivers: IDriverManifestsDriver[]
  driver: IDriverManifestsDriver
  selectedDriver: IDriverManifestsDriver | null
  setSelectedDriver: (value: IDriverManifestsDriver) => void
  setSelectedTrip: (value: IDriverManifestsTrip | null) => void
}

const DriverManifestsDriverItem = (props: IDriverManifestsDriverItemProps) => {
  const { drivers, driver, selectedDriver, setSelectedDriver, setSelectedTrip } = props
  const [alertCount, setAlertCount] = useState<number>(0)
  const [isSelected, setIsSelected] = useState<boolean>(false)

  useEffect(() => {
    retrieveAlertCount()
  }, [drivers])

  useEffect(() => {
    if (selectedDriver && selectedDriver.operatorId === driver.operatorId) {
      setIsSelected(true)
    } else {
      setIsSelected(false)
    }
  }, [selectedDriver])

  const retrieveAlertCount = () => {
    const tripsWithIssues = driver.trips.filter(trip => trip.hasIssue)
    setAlertCount(tripsWithIssues.length)
  }

  const truncateText = (text: string): string => {
    return text.length > 35 ? `${text.slice(0, 30)}...` : text
  }

  return (
    <div
      className={isSelected ? 'dm-driver-item dm-driver-item-selected' : 'dm-driver-item'}
      role='button'
      onClick={() => setSelectedDriver(driver)}
      aria-label='Select Driver Item'
    >
      <div className='dm-driver-item-details-section'>
        <div className='dm-driver-header flex flex-row'>
          {`${driver.firstName} ${driver.lastName}`.length > 35 ? (
            <UpdatedTooltip text={`${driver.firstName} ${driver.lastName}`}>
              <div className='nowrap overflow-hidden'>{truncateText(`${driver.firstName} ${driver.lastName}`)}</div>
            </UpdatedTooltip>
          ) : (
            <div className='nowrap overflow-hidden'>
              {driver.firstName} {driver.lastName}
            </div>
          )}
          <div className='dm-driver-subtitle nowrap'>, Trips: {driver.trips.length}</div>
        </div>
        <div className='dm-driver-subtitle'>
          Vehicle: {driver.vehicle ? `${driver.vehicle.model} (${driver.vehicle.licensePlate})` : 'No Vehicle'}
        </div>
      </div>
      <div>{alertCount > 0 && <div className='dm-alert-tag'>{alertCount}</div>}</div>
    </div>
  )
}

export default DriverManifestsDriverItem



// WEBPACK FOOTER //
// ./src/components/driver-manifests/DriverManifestsDriverItem.tsx